import { render, staticRenderFns } from "./expenseItemsDepCat.vue?vue&type=template&id=479d0c2c&"
import script from "./expenseItemsDepCat.vue?vue&type=script&lang=js&"
export * from "./expenseItemsDepCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports